const theme = require('norska/theme');
const config = require('./_scripts/config.js');

(async () => {
  await theme.init(config);

  // Add archive notice banner before hits
  const hitsContainer = document.getElementById('hits');
  if (hitsContainer) {
    const banner = document.createElement('div');
    banner.id = 'archiveNotice';
    banner.setAttribute('role', 'alert');
    banner.innerHTML =
      '<strong>Archive Notice:</strong> This project has been archived. The underlying Reddit API is no longer available, so data updates have been discontinued. The data displayed is frozen as of September 5, 2021.';
    hitsContainer.parentNode.insertBefore(banner, hitsContainer);
  }
})();
